import { render, staticRenderFns } from "./joystick_index.vue?vue&type=template&id=ab5071da&scoped=true&"
import script from "./joystick_index.vue?vue&type=script&lang=js&"
export * from "./joystick_index.vue?vue&type=script&lang=js&"
import style0 from "./joystick_index.vue?vue&type=style&index=0&id=ab5071da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5071da",
  null
  
)

export default component.exports